export const skills = [
  {
    id: 1,
    title: 'Languages',
    skillItem: [
      {
        name: '',
        fAwesome: 'fab fa-js-square',
      },
      {
        name: '',
        fAwesome: 'fab fa-java',
      },
      {
        name: 'Typescript',
        fAwesome: 'null',
      },
      {
        name: 'C#',
        fAwesome: 'null',
      },
      {
        name: 'SQL',
        fAwesome: 'null',
      },
      {
        name: '',
        fAwesome: 'fab fa-html5',
      },
      {
        name: '',
        fAwesome: 'fab fa-css3-alt',
      },
      {
        name: '',
        fAwesome: 'fab fa-sass',
      },
    ],
  },
  {
    id: 2,
    title: 'Frameworks',
    skillItem: [
      {
        name: '',
        fAwesome: 'fab fa-react',
      },
      {
        name: 'Next.Js',
        fAwesome: '',
      },
      {
        name: '',
        fAwesome: 'fab fa-vuejs',
      },
      {
        name: '',
        fAwesome: 'fab fa-node',
      },
      {
        name: 'ASP.NET',
        fAwesome: 'null',
      },
      {
        name: '',
        fAwesome: 'fab fa-bootstrap',
      },
    ],
  },
  {
    id: 3,
    title: 'Other',
    skillItem: [
      {
        name: 'OPP',
        fAwesome: 'null',
      },
      {
        name: 'MVC',
        fAwesome: 'null',
      },
      {
        name: '',
        fAwesome: 'fab fa-git',
      },
      {
        name: '',
        fAwesome: 'fab fa-github',
      },
      {
        name: '',
        fAwesome: 'fab fa-aws',
      },
      {
        name: 'Azure',
        fAwesome: 'null',
      },
      {
        name: '',
        fAwesome: 'fab fa-figma',
      },
    ],
  },
  {
    id: 4,
    title: 'Adobe',
    skillItem: [
      { name: 'Photoshop' },
      { name: 'Illustrator' },
      { name: 'Lightroom' },
      { name: 'InDesign' },
      { name: 'Xd' },
    ],
  },
]